import React from "react";
import { NumberInput } from "react-admin";
import PlayerStats from "./PlayerStats";

const SoccerPlayerStats = ({ s }) => {
  return (
    <PlayerStats s={s}>
      <NumberInput label="Total Goals" source={s("totalGoals")} />
    </PlayerStats>
  );
};

export default SoccerPlayerStats;
